// Tenant service for multi-tenant operations
export const tenantService = {
  /**
   * Get the current tenant code from localStorage
   * This reads from the same location where TenantContext stores the current tenant
   */
  getCurrentTenantCode: (): string => {
    try {
      const storedTenantJson = localStorage.getItem('currentTenant');
      if (storedTenantJson) {
        const storedTenant = JSON.parse(storedTenantJson);
        if (storedTenant && storedTenant.code) {
          return storedTenant.code;
        }
      }
    } catch (e) {
      console.error('Error parsing stored tenant:', e);
    }
    
    // Fallback to 'dm' (Distill Mobile) as default
    return 'dm';
  },
};